export function ExclamationCircleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='0.333008' width='20' height='20' rx='10' fill='currentColor' />
      <path
        d='M10.333 7.33333V10M10.333 12.6667H10.3397M16.333 10C16.333 13.3137 13.6467 16 10.333 16C7.0193 16 4.33301 13.3137 4.33301 10C4.33301 6.68629 7.0193 4 10.333 4C13.6467 4 16.333 6.68629 16.333 10Z'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
